import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AnnotationPanel = ({ isOpen, onToggle, onAddAnnotation, annotations }) => {
  const [newAnnotation, setNewAnnotation] = useState({
    type: '',
    title: '',
    description: '',
    coordinates: ''
  });

  const annotationTypes = [
    { value: 'observation', label: 'Wildlife Observation' },
    { value: 'threat', label: 'Threat Detection' },
    { value: 'research', label: 'Research Finding' },
    { value: 'maintenance', label: 'Maintenance Need' },
    { value: 'other', label: 'Other' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (newAnnotation?.type && newAnnotation?.title) {
      onAddAnnotation({
        ...newAnnotation,
        id: Date.now(),
        timestamp: new Date()?.toISOString(),
        author: 'Current User'
      });
      setNewAnnotation({ type: '', title: '', description: '', coordinates: '' });
    }
  };

  return (
    <div className={`absolute bottom-24 left-4 bg-card rounded-lg shadow-conservation-lg transition-all duration-300 z-[400] ${isOpen ? 'w-96' : 'w-12'}`}>
      <button
        onClick={onToggle}
        className="w-full p-3 flex items-center justify-between hover:bg-muted/50 rounded-t-lg transition-colors"
        aria-label={isOpen ? 'Close annotations' : 'Open annotations'}
      >
        <span className={`font-medium text-foreground ${isOpen ? 'block' : 'hidden'}`}>Field Annotations</span>
        <Icon name={isOpen ? 'ChevronLeft' : 'MessageSquare'} size={20} color="var(--color-foreground)" />
      </button>
      {isOpen && (
        <div className="p-4 space-y-4 max-h-[32rem] overflow-y-auto">
          <form onSubmit={handleSubmit} className="space-y-3 pb-4 border-b border-border">
            <Select
              label="Annotation Type"
              options={annotationTypes}
              value={newAnnotation?.type}
              onChange={(value) => setNewAnnotation({ ...newAnnotation, type: value })}
              placeholder="Select type"
              required
            />
            
            <Input
              label="Title"
              type="text"
              placeholder="Brief description"
              value={newAnnotation?.title}
              onChange={(e) => setNewAnnotation({ ...newAnnotation, title: e?.target?.value })}
              required
            />
            
            <Input
              label="Details"
              type="text"
              placeholder="Additional information"
              value={newAnnotation?.description}
              onChange={(e) => setNewAnnotation({ ...newAnnotation, description: e?.target?.value })}
            />
            
            <Input
              label="Coordinates"
              type="text"
              placeholder="Lat, Lng (optional)"
              value={newAnnotation?.coordinates}
              onChange={(e) => setNewAnnotation({ ...newAnnotation, coordinates: e?.target?.value })}
            />
            
            <Button type="submit" variant="default" fullWidth iconName="Plus">
              Add Annotation
            </Button>
          </form>
          
          <div className="space-y-3">
            <h4 className="font-medium text-foreground text-sm">Recent Annotations ({annotations?.length})</h4>
            {annotations?.length === 0 ? (
              <p className="text-sm text-muted-foreground text-center py-4">No annotations yet</p>
            ) : (
              annotations?.map((annotation) => (
                <div key={annotation?.id} className="bg-muted/30 rounded-lg p-3 space-y-2">
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex-1">
                      <div className="font-medium text-foreground text-sm">{annotation?.title}</div>
                      <div className="text-xs text-muted-foreground mt-1">{annotation?.type}</div>
                    </div>
                    <Icon name="MapPin" size={16} color="var(--color-primary)" />
                  </div>
                  {annotation?.description && (
                    <p className="text-xs text-foreground">{annotation?.description}</p>
                  )}
                  <div className="flex items-center gap-2 text-xs text-muted-foreground">
                    <Icon name="User" size={12} />
                    <span>{annotation?.author}</span>
                    <span>•</span>
                    <span>{new Date(annotation.timestamp)?.toLocaleString()}</span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AnnotationPanel;